const COMMON_SECOND_LEVEL_SUFFIXES = new Set([
  "co.uk",
  "org.uk",
  "me.uk",
  "com.au",
  "net.au",
  "org.au",
  "co.nz",
  "com.br",
  "com.mx",
  "co.jp",
  "co.in",
  "com.sg",
])

export type DnsRecord = {
  type: "A" | "CNAME" | "TXT"
  host: string
  value: string
}

export function isApexDomain(domain: string): boolean {
  const labels = domain.toLowerCase().split(".")
  if (labels.length === 2) return true
  return labels.length === 3 && COMMON_SECOND_LEVEL_SUFFIXES.has(labels.slice(-2).join("."))
}

export function getDnsInstructions(domain: string, token: string) {
  const apex = isApexDomain(domain)
  const labels = domain.split(".")
  const suffixLabels = apex && COMMON_SECOND_LEVEL_SUFFIXES.has(labels.slice(-2).join(".")) ? 2 : 1
  const registrableLabels = suffixLabels + 1
  const host = labels.slice(0, -registrableLabels).join(".")

  return {
    kind: apex ? ("apex" as const) : ("subdomain" as const),
    verificationRecord: {
      type: "TXT" as const,
      host: `_makerstack.${domain}`,
      value: `makerstack-verify=${token}`,
    },
    routingRecord: apex
      ? ({ type: "A" as const, host: "@", value: "75.2.60.5" } satisfies DnsRecord)
      : ({
          type: "CNAME" as const,
          host: host || labels[0],
          value: "makerstack.netlify.app",
        } satisfies DnsRecord),
    routingHelp: apex
      ? "Remove conflicting A, AAAA, or CNAME records for @ before adding this A record."
      : "The exact Host/Name label varies by DNS provider.",
  }
}
